<header class="yes-typography-heading-6">
  {{ showroomStocks.name }}
</header>
<section class="yes-typography-body-small" *transloco="let t">
  @if (showroomStocks.stocks.length) {
    <div class="available">
      {{ t('Jewellery available in the store.') }}<br />
      @if (availableSizes(); as sizes) {
        {{ t('Available sizes:') }}
        <span>{{ sizes }}</span>
      }
    </div>
  } @else {
    <div class="unavailable">{{ t('Jewellery unavailable in the store.') }}<br /></div>
  }
  <ng-template #unavailable>
    <div class="unavailable">{{ t('Jewellery unavailable in the store.') }}<br /></div>
  </ng-template>
  <address class="yes-typography-body-small">
    @if (showroomStocks.street) {
      {{ showroomStocks.street }}&nbsp;
    }

    @if (showroomStocks.house) {
      {{ showroomStocks.house }}
    }

    @if (showroomStocks.flat) {
      /{{ showroomStocks.flat }}
    }

    @if (showroomStocks.zip) {
      <br />{{ showroomStocks.zip }}&nbsp;
    }

    @if (showroomStocks.city) {
      {{ showroomStocks.city }}<br />
    }

    {{ showroomStocks.phone }}
  </address>
  <a class="yes-typography-body-small" href="mailto:{{ showroomStocks.email }}">{{
    showroomStocks.email
  }}</a>
</section>
